import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetCourseCategory = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/course_categories/${uuid}`, 'GET', idToken)
}

export const UpdateCourseCategory = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/course_categories/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteCourseCategory = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/course_categories/${uuid}`, 'DELETE', idToken)
}
